import { Component, OnInit, OnDestroy  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CartService } from "../../shared/services/cart-service";
import { EitCart } from '../../shared/classes/eitcart';
import { TypePayment, DB } from '../../shared/services/env.service';
import { TypeOrder, ET_OpzioniCoupon } from '../../shared/services/config-app';
import { EdenredService } from "../../shared/services/edenred-service";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cashpay',
  templateUrl: './cashpay.component.html',
  styleUrls: ['./cashpay.component.scss']
})
export class CashpayComponent implements OnInit, OnDestroy  {

  public cartData: any = {};
  public typeOrder: any = TypeOrder;
  public payType: any = TypePayment;
  public token:any="";
  public vouchers=null;
  cartSub: Subscription;
  isTicket:any = false;


  constructor(private route: ActivatedRoute, private router: Router,
    private cartService: CartService, private eService: EdenredService) {

    this.cartData = new EitCart();
    this.cartSub = new Subscription;
    this.token = null;
    this.vouchers = null;
    this.isTicket = false;
    


  }

  ngOnInit(): void {
    this.token = this.eService.getToken();
    this.vouchers = this.eService.getVouchers();
    this.isTicket = this.token && this.vouchers;

    this.route.queryParams.subscribe(params => {
      if (params && params['isTicket'] ) {
        this.isTicket = parseInt(params['isTicket']);
      }
    });

    this.cartSub.add(this.cartService.cartObs.subscribe(x => {

      if (x) {
        this.cartData = x;
      }

    }));
    /*this.route.queryParams.subscribe(params => {
      this.token = params['token'];
      this.vouchers = JSON.parse(params['vouchers']);
    });*/
  }

  ngOnDestroy() {
    this.cartSub.unsubscribe();
  }


  goToPay() {
    this.router.navigate(['/checkpay'], { queryParams: {} });
  }

  closeOrder() {

    this.token = this.eService.getToken();
    this.vouchers = this.eService.getVouchers();
    this.isTicket = this.token && this.vouchers;
    
    if(this.isTicket)
    {
      this.closeOrderEdenred();
    }else{
      this.closeOrderCash();
    }
  }


  closeOrderCash() {
    var dataPaypal: any = {};
    dataPaypal.restid = this.cartData.rest_id;
    dataPaypal.orderid = this.cartData.order_id;
    dataPaypal.type = TypePayment.MONEY;
    dataPaypal.payment = {};
    dataPaypal.response = {};
    dataPaypal.noteride = "";
    let noteride = localStorage.getItem("noteride");
    if (noteride != undefined && noteride != "undefined" && noteride != null && noteride != "null") {
      dataPaypal.noteride = noteride;
    }
    this.cartService.finalize(dataPaypal);
  }


  closeOrderEdenred() {

    var dataPaypal: any = {};
    dataPaypal.restid = this.cartData.rest_id;
    dataPaypal.orderid = this.cartData.order_id;
    dataPaypal.type = TypePayment.TICKET;
    dataPaypal.stype = TypePayment.MONEY;
    dataPaypal.token = this.token;
    dataPaypal.payment = {};
    dataPaypal.response = {};
    dataPaypal.noteride = "";
    let noteride = localStorage.getItem("noteride");
    if (noteride != undefined && noteride != "undefined" && noteride != null && noteride != "null") {
      dataPaypal.noteride = noteride;
    }

    this.cartService.finalizeEdenred(dataPaypal, this.vouchers);

  }


}
